import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector, useQuery } from "hooks";

import { Box, Theme } from "@mui/system";
import { makeStyles } from "@mui/styles";
import { Divider, Typography } from "@mui/material";

import CustomLayout from "components/atoms/simple-layout";
import CustomButton from "components/atoms/custom-button";
import BackdropLoader from "components/atoms/backdrop-loader";
import OrderCard from "pages/profile/orders/components/OrderCard";
import confirmCheckIcon from "assets/icons/confirm_check_icon.svg";

import { scrollTop } from "utils/commons";
import { getSingleOrder } from "store/orders.slice";

const FailedPurchasePage: FC = () => {
  const s = useStyles();

  const query = useQuery();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const userId = query.get("uid") as string;
  const orderId = query.get("oid") as string;

  const { user } = useAppSelector((state) => state.userInformation);
  const { singleOrder, isLoading } = useAppSelector((state) => state.orders);

  useEffect(() => {
    if (!userId || !orderId) navigate("/");
    else dispatch(getSingleOrder(orderId));
  }, [dispatch, navigate, orderId, userId]);

  const goToCheckout = () => {
    scrollTop();
    navigate("/shopping-cart", { replace: true });
    window.location.reload();
  };

  if (isLoading) return <BackdropLoader />;

  return (
    <CustomLayout pd={2}>
      <Box className={s.imgContainer}>
        <Box
          component="img"
          alt="confirm-icon"
          className={s.icon}
          src={confirmCheckIcon}
        />

        <Typography my={2} align="center" color="text.primary" fontSize={30}>
          Lo sentimos, {user?.firstName} tu compra no ha sido éxitosa
        </Typography>

        <Divider sx={{ my: 3 }} />

        {singleOrder && (
          <Box p={{ sx: 1, md: 2 }} m={{ sx: 0, md: 2 }}>
            <Typography fontSize={16} fontWeight={500} marginBottom={1}>
              Detalles de la compra
            </Typography>
            <OrderCard order={singleOrder} />
          </Box>
        )}

        <CustomButton
          variant="primary"
          text="Volver a intentarlo"
          onClick={goToCheckout}
          sx={{ width: { xs: "100%", md: 254 }, margin: "0 auto" }}
        />
      </Box>
    </CustomLayout>
  );
};

export default FailedPurchasePage;

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    width: 96,
    margin: "0 auto",
    objectFit: "contain",
  },
  imgContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginTop: theme.spacing(6),
  },
}));
